import styled from 'styled-components';
import { Strong } from '@finect/tabular-core/Strong';
export var HoldingName = styled(Strong).withConfig({
  displayName: "partials__HoldingName",
  componentId: "sc-1yzvp6w-0"
})(["display:block;"]);